import React from 'react';

export const DiscountSignalIcon: React.FC = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 10L2.5 6.5L6.5 2.5H9.5C9.77614 2.5 10 2.72386 10 3V6L6 10ZM8.49988 4.625C8.84506 4.625 9.12488 4.34518 9.12488 4C9.12488 3.65482 8.84506 3.375 8.49988 3.375C8.1547 3.375 7.87488 3.65482 7.87488 4C7.87488 4.34518 8.1547 4.625 8.49988 4.625Z"
            fill="#161719"
        />
    </svg>
);
